module.exports = __webpack_public_path__ + "static/cad-designs17-6af198ac871bf099ca73831f78f10b18.png";